(function () {
  var root = document.documentElement;
  var bootingClass = 'ss-customily-breed-dropdown-booting';
  var readyClass = 'ss-customily-breed-dropdown-ready';
  var readyTimer = 0;
  var observer = null;
  var revealObserver = null;
  var revealQueued = false;
  var originalReadyCallback = typeof window.__ssCustomilyBreedDropdownReady === 'function'
    ? window.__ssCustomilyBreedDropdownReady
    : null;

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function breedFromTitle() {
    var title = clean(document.querySelector('.product__title, h1') && document.querySelector('.product__title, h1').textContent);
    return title
      .replace(/^Soulyshine\s+/i, '')
      .replace(/\s+The Fine Line Portrait.*$/i, '')
      .replace(/\s+Whisper of Paws.*$/i, '');
  }

  function normalized(value) {
    return clean(value).toLowerCase();
  }

  function groupForBreed(breed) {
    var first = clean(breed).charAt(0).toUpperCase();
    if (first === 'A') return 'A Dog Breeds';
    if (first === 'B') return 'B Dog Breeds';
    if (first === 'C') return 'C Dog Breeds';
    if (first >= 'D' && first <= 'F') return 'D-F Dog Breeds';
    if (first >= 'G' && first <= 'J') return 'G-J Dog Breeds';
    if (first >= 'K' && first <= 'O') return 'K-O Dog Breeds';
    if (first >= 'P' && first <= 'R') return 'P-R Dog Breeds';
    if (first >= 'S' && first <= 'T') return 'S-T Dog Breeds';
    return 'V-Y Dog Breeds';
  }

  function press(element) {
    if (!element) return;
    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(function (type) {
      var EventClass = type === 'pointerdown' && window.PointerEvent ? window.PointerEvent : window.MouseEvent;
      element.dispatchEvent(new EventClass(type, {
        bubbles: true,
        cancelable: true,
        view: window,
        button: 0,
        pointerId: 1,
        pointerType: 'mouse'
      }));
    });
  }

  function matchingRadio(name, value) {
    return Array.prototype.slice.call(document.querySelectorAll('input[type="radio"]')).find(function (input) {
      return input.name === name && normalized(input.value) === normalized(value);
    });
  }

  function selectRadio(input) {
    if (!input || input.checked) return;
    var label = input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    press(label || input);
  }

  function optionName(option) {
    var title = option && option.querySelector('.option_name');
    return clean(title && title.textContent).replace(/\s+\*\s+Required$/i, '');
  }

  function optionByName(pattern) {
    return Array.prototype.slice.call(document.querySelectorAll('.customily_option')).find(function (option) {
      return pattern.test(optionName(option));
    });
  }

  function radioInOption(option, value) {
    return Array.prototype.slice.call((option || document).querySelectorAll('input[type="radio"]')).find(function (input) {
      return normalized(input.value) === normalized(value);
    });
  }

  function revealOption(option) {
    if (!option) return false;
    if (option.hasAttribute('visually-hidden')) {
      option.removeAttribute('visually-hidden');
    }
    if (option.style.getPropertyValue('display') === 'none') {
      option.style.removeProperty('display');
    }

    if (window.getComputedStyle(option).display === 'none' && option.style.getPropertyValue('display') !== 'flex') {
      option.style.setProperty('display', 'flex', 'important');
    }

    return true;
  }

  function restoreInputName(option, name) {
    Array.prototype.slice.call((option || document).querySelectorAll('input')).forEach(function (input) {
      if (input.name !== name) input.name = name;
    });
  }

  function setOptionNumber(option, number, total) {
    var label = option && option.querySelector('.option_number span');
    var desired = 'Option ' + number + ' of ' + total;
    if (!label) return;
    if (clean(label.textContent) !== desired) {
      label.textContent = desired;
    }
  }

  function revealSelectedBreedPath() {
    var expectedBreed = breedFromTitle();
    if (!expectedBreed) return false;

    var categoryOption = optionByName(/^Choose Dog Breed #1$/i);
    if (!categoryOption) return false;

    revealOption(categoryOption);
    restoreInputName(categoryOption, 'properties[Choose Dog Breed #1]');

    var checkedGroup = Array.prototype.slice.call(categoryOption.querySelectorAll('input[type="radio"]')).find(function (input) {
      return input.checked;
    });
    var selectedGroup = checkedGroup && checkedGroup.value || groupForBreed(expectedBreed);
    var selectedInput = radioInOption(categoryOption, selectedGroup);
    if (root.classList.contains(bootingClass) && selectedInput && !selectedInput.checked) {
      selectRadio(selectedInput);
    }

    var breedOption = optionByName(new RegExp('^' + selectedGroup.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', 'i'));
    if (breedOption) {
      revealOption(breedOption);
      restoreInputName(breedOption, 'properties[' + selectedGroup + ']');
      setOptionNumber(categoryOption, 2, 4);
      setOptionNumber(breedOption, 3, 4);
      setOptionNumber(optionByName(/^Enter Name #1/i), 4, 4);
    }

    return true;
  }

  function queueRevealSelectedBreedPath() {
    if (revealQueued) return;
    revealQueued = true;
    window.requestAnimationFrame(function () {
      revealQueued = false;
      revealSelectedBreedPath();
    });
  }

  function startRevealObserver() {
    if (revealObserver) return;
    revealObserver = new MutationObserver(queueRevealSelectedBreedPath);
    revealObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'visually-hidden', 'name', 'checked', 'class']
    });
    queueRevealSelectedBreedPath();
  }

  function markBreedDropdownReady() {
    root.classList.remove(bootingClass);
    root.classList.add(readyClass);
    document.querySelectorAll('.csh-dropdown-panel, .csh-dropdown-items-container').forEach(clearInlinePanelState);
    revealSelectedBreedPath();
    startRevealObserver();

    if (originalReadyCallback && originalReadyCallback !== markBreedDropdownReady) {
      originalReadyCallback();
    }
  }

  function applyExpectedBreed() {
    var expectedBreed = breedFromTitle();
    if (!expectedBreed) return false;

    selectRadio(matchingRadio('properties[Choose Number Of Dogs]', '1'));
    selectRadio(matchingRadio('properties[Choose Dog Breed #1]', groupForBreed(expectedBreed)));
    revealSelectedBreedPath();

    var container = Array.prototype.slice.call(document.querySelectorAll('.csh-dropdown-container')).find(function (candidate) {
      return isBreedDropdownElement(candidate);
    });
    if (!container) return false;

    var label = clean(container.querySelector('.csh-dropdown-label') && container.querySelector('.csh-dropdown-label').textContent);
    if (normalized(label) === normalized(expectedBreed)) return true;

    var control = container.querySelector('.csh-dropdown-input-container');
    if (control && !container.querySelector('.csh-dropdown-items-container')) {
      press(control);
    }

    var item = Array.prototype.slice.call(document.querySelectorAll('.csh-dropdown-item-text')).find(function (candidate) {
      return normalized(candidate.textContent) === normalized(expectedBreed);
    });

    if (!item) return false;
    press(item.closest('.csh-dropdown-item') || item);
    return true;
  }

  function optionNameFor(element) {
    var container = element && element.closest && element.closest('.csh-dropdown-container');
    var option = container && container.closest('.customily_option');
    var title = option && option.querySelector('.option_name');
    return clean(title && title.textContent).replace(/\s+\*\s+Required$/i, '');
  }

  function isBreedDropdownElement(element) {
    var name = optionNameFor(element);
    if (/^Choose Dog Breed #\d+/i.test(name) || /Dog Breeds/i.test(clean(element && element.textContent))) {
      return true;
    }

    return Boolean(element && element.closest && element.closest(
      '.csh-dropdown-container, .csh-dropdown-input-container, .csh-dropdown-panel, .csh-dropdown-items-container, .csh-dropdown-item'
    ));
  }

  function clearInlinePanelState(panel) {
    panel.style.removeProperty('display');
    panel.style.removeProperty('opacity');
    panel.style.removeProperty('visibility');
    panel.style.removeProperty('pointer-events');
  }

  function closeBreedDropdowns() {
    document.querySelectorAll('.csh-dropdown-input-container.csh-active').forEach(function (control) {
      if (!isBreedDropdownElement(control)) return;
      control.classList.remove('csh-active');
      control.setAttribute('aria-expanded', 'false');
    });

    document.querySelectorAll('.csh-dropdown-panel, .csh-dropdown-items-container').forEach(function (panel) {
      if (!isBreedDropdownElement(panel)) return;
      panel.style.setProperty('display', 'none', 'important');
      panel.style.setProperty('opacity', '0', 'important');
      panel.style.setProperty('visibility', 'hidden', 'important');
      panel.style.setProperty('pointer-events', 'none', 'important');
    });

    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  function releaseGuard() {
    window.clearTimeout(readyTimer);
    if (observer) observer.disconnect();
    markBreedDropdownReady();
  }

  function selectedBreedIsStable() {
    var expectedBreed = clean(breedFromTitle()).toLowerCase();
    return Array.prototype.slice.call(document.querySelectorAll('.csh-dropdown-container')).some(function (container) {
      if (!isBreedDropdownElement(container)) return false;
      var label = clean(container.querySelector('.csh-dropdown-label') && container.querySelector('.csh-dropdown-label').textContent);
      return label && !/Dog Breeds$/i.test(label) && (!expectedBreed || label.toLowerCase() === expectedBreed);
    });
  }

  function scheduleReleaseWhenStable() {
    if (!selectedBreedIsStable()) return;
    window.clearTimeout(readyTimer);
    readyTimer = window.setTimeout(function () {
      closeBreedDropdowns();
      releaseGuard();
    }, 350);
  }

  function boot() {
    window.__ssCustomilyBreedDropdownReady = markBreedDropdownReady;
    startRevealObserver();

    if (!root.classList.contains(bootingClass) && !root.classList.contains(readyClass)) {
      root.classList.add(bootingClass);
    }

    document.addEventListener('pointerdown', function (event) {
      if (event.isTrusted && isBreedDropdownElement(event.target)) {
        releaseGuard();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.isTrusted && root.classList.contains(bootingClass)) {
        releaseGuard();
      }
    }, true);

    observer = new MutationObserver(function () {
      if (!root.classList.contains(bootingClass)) return;
      applyExpectedBreed();
      revealSelectedBreedPath();
      closeBreedDropdowns();
      scheduleReleaseWhenStable();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-expanded']
    });

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (!root.classList.contains(bootingClass)) {
        window.clearInterval(timer);
        return;
      }

      applyExpectedBreed();
      revealSelectedBreedPath();
      closeBreedDropdowns();
      scheduleReleaseWhenStable();

      if (attempts > 40 || selectedBreedIsStable()) {
        window.clearInterval(timer);
      }
    }, 250);

    applyExpectedBreed();
    revealSelectedBreedPath();
    closeBreedDropdowns();
    scheduleReleaseWhenStable();

    window.setTimeout(function () {
      if (!root.classList.contains(bootingClass)) return;
      window.clearInterval(timer);
      closeBreedDropdowns();
      releaseGuard();
    }, 7000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

(function () {
  if (window.__ssCustomilyVyRoseThumbnailOverrideLoader) return;
  window.__ssCustomilyVyRoseThumbnailOverrideLoader = true;

  function loadOverride() {
    if (document.querySelector('script[src*="customily-vy-rose-thumbnail-override"]')) return;

    var current = document.currentScript && document.currentScript.src || '';
    var src = current && current.indexOf('customily-close-initial-breed-dropdown.js') !== -1
      ? current.replace('customily-close-initial-breed-dropdown.js', 'customily-vy-rose-thumbnail-override-v2.js')
      : '/cdn/shop/t/16/assets/customily-vy-rose-thumbnail-override-v2.js';
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }

  if (document.head) {
    loadOverride();
  } else {
    document.addEventListener('DOMContentLoaded', loadOverride, { once: true });
  }
})();
